import {getDatabase, ref, set, get, push, update} from "firebase/database";
import useFlex from "../json/flex.json";

function setSchedule(auth_user, classes, fromLocal=false) {
    return new Promise((resolve, reject) => {
        const db = getDatabase();
        if (!fromLocal) {
        classes = JSON.parse(classes);
        classes = classes.filter((c) => !c[0].includes("Independent Study"))

        var parsedNames = classes.map((c) => {
            if (!c[0].includes("Independent Study")) {
                c[0] = c[0].replace("PE-C", "Sci C")
            return [c[0].split("-").slice(0, -1).join("-"), c[0].split("-").at(-1).split("(")[0].replace(/ /g, ""), c[0].split("-").at(-1).split("(")[1].replace(")", "").replace(/ /g, "")]}})
        var userClasses = processClasses(classes, parsedNames)
        } else {
            var parsedNames = Object.values(classes.classes).map((c) => {
                return [c.id]})
        }
        resetUserClasses(auth_user.uid).then((u) => {
            if (u === null) {
                if (!fromLocal) {
        var user = {classes: userClasses, info:{
            name: auth_user.displayName,
            email: auth_user.email,
            photo: auth_user.photoURL,
        }};
                } else {
                    var user = classes;
                }
    } else {
            var user = {classes: userClasses, info: u.info, settings: u.settings || null};
        } 
        set(ref(db, 'users/' + auth_user.uid), user)
        .then(() => {
            
            get(ref(db, 'classes/')).then((snapshot) => {
                var allClasses = {};
                if (snapshot.exists()) {
                    allClasses = snapshot.val();
                }
                parsedNames.forEach((c, i) => {
                    if (!fromLocal) {
                    var cid = c[0] + c[1] + c[2];
                    } else {
                        var cid = c[0];
                    }
                    if (allClasses[cid] === undefined) {
                        if (!fromLocal) {
                            classes[i][0] = classes[i][0].split("-").slice(0, -1).join("-")
                        createClass(cid, classes[i], auth_user.uid);
                        } else {
                            fromLocal[i][0] = fromLocal[i][0].split(" ").slice(0, -1).join(" ")
                            createClass(cid, fromLocal[i], auth_user.uid);
                        }
                    } else {
                        if (!fromLocal) {
                        classes[i][0] = classes[i][0].split("-").slice(0, -1).join("-")
                        joinClass(cid, classes[i], auth_user.uid);
                        } else {
                            fromLocal[i][0] = fromLocal[i][0].split(" ").slice(0, -1).join(" ")
                            joinClass(cid, fromLocal[i], auth_user.uid);
                        }
                    }
                })
                resolve();
            }).catch((error) => {
                reject(error);
            })

    })
})
    })
}

function createClass(cid, c, uid) {
    console.log("creating class", cid, c);
    return new Promise((resolve, reject) => {
        const db = getDatabase();
        var classObj = {name: c[0], teacher: c[1], room: c[2], users: {[uid]:true}};
        set(ref(db, 'classes/' + cid), classObj)
        .then(() => {
            resolve();
        })
        .catch((error) => {
            reject(error);
        });
    })
}

function joinClass(cid, c, uid) {
    return new Promise((resolve, reject) => {
        const db = getDatabase();
        var classObj = {name: c[0], teacher: c[1], room: c[2]};
        set(ref(db, 'classes/' + cid+'/users/'+uid), true).then((snapshot) => {
            update(ref(db, 'classes/'+cid), classObj).then(() => {
            resolve(); 
            }).catch((e) => {
                reject(e);
            })
        }).catch((error) => {
            reject(error);
        })
    })
    }

    function getUser(uid) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            console.log(uid)
            get(ref(db, 'users/' + uid)).then((snapshot) => {
                console.log(snapshot.val())
                if (snapshot.exists()) {
                    var user = snapshot.val();
                    if (!user.hasOwnProperty("settings")) user.settings = {tname:true, rnumber:true, period:false, pe:false, wschedule:false, coverride:false, homework:""}; 
                    resolve(user);
                } else {
                    resolve(null);
                }

            }).catch((error) => {
                reject(error);
            })
        })
    }

    function processClasses(classes, parsedNames, local=false) {
        var sciences = {"A Science":["A", "A Sci"], "B Science":["B", "B Sci"], "C Science":["C", "C Sci"], "D Science":["D", "CL1"], "E Science":["E", "Clark 3"],"F Science":["F", "W5"]}
        var out = {}
        for (let c = 0; c < classes.length; c++) {
            console.log(classes[c])
            if (!classes[c][0].includes("Independent Study") && !classes[c][0].includes("Civic Lab")) {
            var params = {}
            if (local) {
                params.tname = classes[c][1]
                params.rnumber = classes[c][2]
            }
            var block = classes[c][0].split("(").slice(-1)[0].replace(")", "")
            block = block.split(", ")
            if (block[0] in sciences) {
              params.color = sciences[block[0]][0]
              block = sciences[block[0]]
      
      
            }
            if (useFlex[classes[c][0].split(" -").slice(0, -1).join(" -")]){
                params.flex = true;
            }

            const ARTS = {"Advanced Choral Ensemble":[1, 3, 5, 8], "Advanced Wind Ensemble":[1, 4, 7, 8], "Concert Band":[3, 4, 6], "Intro to Dance":[1, 2, 5, 8], "Jazz Band":[2, 5], "Concert Choir":[2, 4, 6, 8], "Orchestra":[1,3,5,8], "Advanced Dance":[3, 4, 7, 8]}
            if (Object.keys(ARTS).includes(classes[c][0].split(" -")[0])) {
                var periods = ARTS[classes[c][0].split(" -")[0]]
                block = []
                periods.forEach(function (p) {
                    block.push("ARTS "+p)
                })
            }

           // var name = classes[c][0].split(" -").slice(0, -1).join(" -")
          //  if (!classes[c][0].split(" -")[0].includes("Advanced Choral Ensemble")) {
                console.log(classes[c])
            block.forEach(function (b) {
              if (!classes[c][0].split(" -")[0].includes("Life Kit") && !classes[c][0].split(" -")[0].includes("Phys Ed")) {
              out[b.replace(/CL/g, "Clark ").replace(/W/g, "Webster ")] = {
                id:parsedNames[c].join(""),
                params: params,
              }
              } else if (classes[c][0].split(" -")[0].includes("Phys Ed")) {
        
            } else {
                var pe = classes.indexOf(classes.filter((c) => c[0].includes("Phys Ed"))[0])
                console.log(pe)
                var grade = classes[c][0].split("th")[0]
                for (var i = 9; i <= 12; i++) {
                  if (i == parseInt(grade)) {
                    console.log(i)
                    out["Wellness "+(i)] = {
                      id:parsedNames[c].join(""),
                      params: params,
                    }
                  } else {
                    if (local) {
                        params.tname = classes[pe][1]
                        params.rnumber = classes[pe][2]
                    }
                  out["Wellness "+(i)] = {
                    id:parsedNames[pe].join(""),
                    params: params,
                  }
                }
                }
            }
            })
        //   } else {
        //     out["Webster 3"] = {
        //         id:parsedNames[c].join(""),
        //         params: params,
        //       }
        //     out["Webster 5"] ={
        //         id:parsedNames[c].join(""),
        //         params: params,
        //       }
        //     out["GJ"] = {
        //         id:parsedNames[c].join(""),
        //         params: params,
        //       }
        //   }
        }}
    
        // if (!out.hasOwnProperty("A Sci")) {
        //   out["A Sci"] = ["Conference", "", {color:"Lunch", main:true}, ""]
        // }
    
        // if (!out.hasOwnProperty("B Sci")) {
        //   out["B Sci"] = ["Conference", "", {color:"Lunch", main:true}, ""]
        // }
    
        // if (!out.hasOwnProperty("C Sci")) {
        //   out["C Sci"] = ["Conference", "", {color:"Lunch", main:true}, ""]
        // }
        console.log(out)
        return out;
      }

      function getClasses() {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            get(ref(db, 'classes/')).then((snapshot) => {
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                } else {
                    resolve(null);
                }

            }).catch((error) => {
                reject(error);
            })
        })
      }

      function getClass(cid) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            get(ref(db, 'classes/' + cid)).then((snapshot) => {
                if (snapshot.exists()) {
                    resolve([cid, snapshot.val()]);
                } else {
                    resolve(null);
                }

            }).catch((error) => {
                reject(error);
            })
        })
        }

      function saveSettings(uid, settings) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            var flexes = settings.flex;
            delete settings.flex;
            var promises = [];
            Object.entries(flexes).forEach((f) => {
                if (f[1]) {
                    promises.push(set(ref(db, 'users/' + uid+'/classes/' + f[0] +"/params/flex"), true))
                } else {
                    promises.push(set(ref(db, 'users/' + uid+'/classes/' + f[0] + "/params/flex"), null))
                }
            })
            promises.push(set(ref(db, 'users/' + uid + "/settings"), settings))
            Promise.all(promises)
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
        })
    }

    function getUsers() {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            get(ref(db, 'users/')).then((snapshot) => {
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                } else {
                    resolve(null);
                }
            })
        })
    }

    function saveGCConfig(uid, refresh_token) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            set(ref(db, 'users/' + uid + "/settings/gcconfig/refresh_token"), refresh_token).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            })
        })
    }

    function resetUserClasses(uid) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            get(ref(db, 'users/' + uid)).then((snapshot) => {
                console.log(snapshot.val())
                if (!snapshot.exists() || snapshot.val() === null) {
                    resolve(null);
                    return;
                }
                var val = snapshot.val();
                var classes = val.classes;
                var promises = [];
                Object.values(classes).forEach((c) => {
                    promises.push(set(ref(db, 'classes/' + c.id + "/users/" + uid), null))
                    
                })
                if (val.hasOwnProperty("settings") && val.settings.hasOwnProperty("gcconfig")) {
                    delete val.settings.gcconfig.courses;
                }
                Promise.all(promises).then(() => {
                    resolve(val);
                }).catch((error) => {
                    reject(error);
                })
            })
           

        })
    }

    function getClubs() {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            get(ref(db, 'clubs/')).then((snapshot) => {
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                } else {
                    resolve({});
                }
            })
        })
    }

    function addClub(uid, club, color) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            var clubObj = {color: color, owner: uid, pending:true};
            set(ref(db, 'clubs/'+club), clubObj)
            .then(() => {
                resolve(clubObj);
            })
            .catch((error) => {
                reject(error);
            });
        })
    }

    function addMeeting(club, type, day, start, end) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            var meeting = {type: type, day: day, time: {start: start, end: end}};
            push(ref(db, 'clubs/'+club+"/meetings/"), meeting)
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
        })
    }

    function watchedTutorial(uid) {
        return new Promise((resolve, reject) => {
            const db = getDatabase();
            var settings = {tname:true, rnumber:true, tutorial:true};
            set(ref(db, 'users/' + uid + "/settings"), settings).then(() => {
                resolve();
            }).catch((error) => {
                reject(error);
            })
        })
    }

    export {setSchedule, getUser, getClasses, saveSettings, saveGCConfig, getClass, getUsers, processClasses, getClubs, addClub, addMeeting, watchedTutorial};